import { useCallback, useEffect } from 'react';
import { useSession } from '@lib/auth/client';
import { useAnalytics } from '@contexts/use-analytics';
import { getReferralCode } from '@utils/referral-code';
import type { SavvySession } from '@auth';

export function SessionHandler() {
  const { data: session } = useSession();
  const { emitSignUpEvent } = useAnalytics();

  const handleFirstSession = useCallback(
    (session: SavvySession) => {
      if (!window.localStorage) return;
      const storageKey = `__savvy_first_session_handled_${session.user.id}`;
      if (localStorage.getItem(storageKey) !== 'true') {
        const referralCode = getReferralCode(undefined);
        emitSignUpEvent(session.user, referralCode ? 'referral' : undefined);
        localStorage.setItem(storageKey, 'true');
      }
    },
    [emitSignUpEvent]
  );

  useEffect(() => {
    if (session?.user?.id && session.isFirstSession) {
      handleFirstSession(session);
    }
  }, [session, handleFirstSession]);

  return null;
}
